import { useUseCases } from "@/context/UseCasesProvider";

interface Entity {
  entity_id: string;
  entity_name: string;
  entity_address: string;
  entity_postalCode: string;
  entity_city: string;
  entity_email: string[];
  entity_domain_toSkip?: string[];
  entity_color?: string;
  entity_initials?: string;
}

interface EntitiesResult {
  entities: Entity[];
  loading: boolean;
  error: Error | null;
}

const useEntities = (): EntitiesResult => {
  const data = useUseCases();

  const entities = data?.settings?.entities ?? [];

  return {
    entities,
    loading: false,
    error: null
  };
};

export default useEntities;